module.exports = __webpack_public_path__ + "static/media/image-3.a90f5989.avif";